exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#relation-log-table table tbody td{\n    align-content: flex-start;\n}\n", ""]);

// exports
